import * as React from 'react';
import styled from 'styled-components';
import { Icon, IIconProps } from '../../../icon';
import { selectThemeSemantics } from '../../../../styling';

interface INavigationButtonProps extends Pick<IIconProps, 'iconName' | 'iconSize'>, React.HTMLProps<HTMLDivElement> { }

const StyledIcon = styled(Icon)`
    fill: ${selectThemeSemantics(({ palette }) => palette.black)};
`;

const NavigationButtonBase = React.memo((props: INavigationButtonProps) => {
    const { iconName, iconSize, hidden, ...rest } = props;
    return (
        hidden
            ? null
            : React.createElement('div', rest, <StyledIcon iconName={iconName} iconSize={iconSize} />)
    );
});

NavigationButtonBase.displayName = 'NavigationButton';

export const NavigationButton = styled(NavigationButtonBase).attrs({
    className: String('ap-toolbar-navigationButton')
})`
    height: 100%;
    width: 30px;
    display: ${({ hidden }) => (hidden ? 'none' : 'inline-flex')};
    justify-content: center;
    align-items: center;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};

    &:hover {
        opacity: ${({ disabled }) => (disabled ? '0.5' : '0.7')};
    }
`;
